import { render, staticRenderFns } from "./TextXhrSelectComponent.vue?vue&type=template&id=12069dc7&scoped=true"
import script from "./TextXhrSelectComponent.vue?vue&type=script&lang=js"
export * from "./TextXhrSelectComponent.vue?vue&type=script&lang=js"
import style0 from "./TextXhrSelectComponent.vue?vue&type=style&index=0&id=12069dc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12069dc7",
  null
  
)

export default component.exports